export default "__VITE_ASSET__DYN09dDx__"